import { render, staticRenderFns } from "./passengerFlow.vue?vue&type=template&id=28ca27c2&scoped=true&"
import script from "./passengerFlow.vue?vue&type=script&lang=js&"
export * from "./passengerFlow.vue?vue&type=script&lang=js&"
import style0 from "./passengerFlow.vue?vue&type=style&index=0&id=28ca27c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ca27c2",
  null
  
)

export default component.exports